import { render } from "./MenuMobileLinks.vue?vue&type=template&id=47f6de24&scoped=true"
import script from "./MenuMobileLinks.js?vue&type=script&lang=js&external"
export * from "./MenuMobileLinks.js?vue&type=script&lang=js&external"

import "./MenuMobileLinks.scss?vue&type=style&index=0&id=47f6de24&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f6de24"]])

export default __exports__